// Storage utilities for "Remember Me" functionality
// Since Supabase uses localStorage by default, we'll manage clearing sessions
// when "Remember Me" is unchecked

const REMEMBER_ME_KEY = 'tablein_remember_me'
const SESSION_START_KEY = 'tablein_session_start'

export const getRememberMePreference = (): boolean => {
  // Default to true (remember by default)
  const stored = localStorage.getItem(REMEMBER_ME_KEY)
  return stored === null ? true : stored === 'true'
}

export const setRememberMePreference = (remember: boolean): void => {
  if (remember) {
    localStorage.setItem(REMEMBER_ME_KEY, 'true')
    // Clear the session start marker since we're now remembering
    sessionStorage.removeItem(SESSION_START_KEY)
  } else {
    localStorage.setItem(REMEMBER_ME_KEY, 'false')
    // Mark that this session should not persist
    sessionStorage.setItem(SESSION_START_KEY, Date.now().toString())
  }
}

// Check if we should clear the session on page load
// This runs when the app starts to handle "don't remember" preference
export const checkAndClearSessionIfNeeded = (): void => {
  const rememberMe = getRememberMePreference()
  const sessionStart = sessionStorage.getItem(SESSION_START_KEY)
  
  // If "Remember Me" is false AND this is a new browser session (no sessionStart marker)
  // Clear any existing Supabase session from localStorage
  if (!rememberMe && !sessionStart) {
    // Clear all Supabase-related keys from localStorage
    const keys = Object.keys(localStorage)
    keys.forEach(key => {
      if (key.startsWith('sb-') || key.includes('supabase')) {
        localStorage.removeItem(key)
      }
    })
  }
  
  // If "Remember Me" is false, ensure we have a session start marker
  // This helps us detect new browser sessions
  if (!rememberMe && !sessionStart) {
    sessionStorage.setItem(SESSION_START_KEY, Date.now().toString())
  }
}
